<template>
	<v-touch @swipeleft="swiperleft" @swiperight="swiperight" class="frame">
		<div class="container-box">
			<!-- 顶部 -->
			<div class="header">
				<div class="headerFrame">
					<tabBar></tabBar>
				</div>
			</div>
			<!-- 内容 -->
			<div class="content">

				<!-- 山哩商城 -->
				<div class="shoppingMall">
					<div style="padding-left: 20px; padding-right: 20px;padding-top: 30px;">
						<div class="title">”E法通”不良资产处置优势</div>
						<div class="textContent">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;山哩顺应监管政策趋严和行业合规化、资产甲方的要求、精细化运营内部需求等大趋势，打造不良资产智能解决方案。即人工法催调诉及法律科技应用服务一体化智能解决方案:通过人工+互联网智
							能多元处置模式实现调解、诉讼环节的标准化运营;通过借助法律科技应用服务，实现金额小、大体量、分散性的个贷类和消费金融等不良资产规模化案件管理和解决;同时将当下紧缺的司法资源价
							值最大化。</div>
						<div class="textBottom">处置方案优势如下:</div>
					</div>
					<div
					v-for="item in texts"
						style="padding-left: 20px; padding-right: 20px;padding-top: 30px;padding-bottom: 30px; background-color: white; border-radius: 10px;margin-bottom: 30px;">
						<div class="childTiltle">{{item.titel}}</div>
						<div class="childContent">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}</div>
						<div class="childImg">
							<img v-for="img in item.imgs" :src="img" style="height: 100%;width: 100%;"/>
						</div>
					</div>
				</div>
			</div>
			<fixedBottomRight></fixedBottomRight>
		</div>
	</v-touch>
</template>

<script>
	import tabBar from "@/assembly/tabBarNew.vue";
	import swiper from "@/assembly/mobileSwiper.vue";
	import fixedBottomRight from '@/assembly/fixedBottomRight.vue';
	import {
		getHome
	} from "../../api/home.js";
	export default {
		name: "index",
		data() {
			return {
				tabBarTitle: "新消费智慧供应链生态运营平台",
				tabBarTitle1: "专业化 精细化 特色化 新颖化",
				premiumService: "线上App平台为依托, 探索集成式便民新零售发展路线,",
				premiumService1: "在全国范围布局山哩优品生活服务店",
				farmFrameChildFont: "投资零售和消费品家庭农场作坊, 助力农村经济发展,解决农民就业;同时打造自有品牌、完善自身供应链体系.",
				businessFooterFontContent: "通过商学院联盟, 实现",
				businessFooterFontContent1: "'共创、共享、共生，让事业无边界'",
				show1: false, // 定义第一个div的数据
				show2: false, // 定义第二个div的数据
				show3: false, // 定义第三个div的数据
				article: [],
				banners: [],
				texts: [
					{
						titel: "一，”E法通”不良资产处置优势",
						content: "“E法通”通过法院多线路专属调解专线，电话一键外呼、在线视频调解和批量预测式外呼高效触达用户，快速生成批量调解卷宗，发送文书短信催记管理;同债务人签署调解函，进行司法确认，重新生成还款计划对不履行调解协议的当事人进行强制执行申请。调解无效情况下，直接线上转立案，批量立案，高效执行。并将设定通过“E法通”法律科技软件进行全流程、全终端的纠纷化解工作，录音存证及大数据计算等工作。",
						imgs: [
							require("@/assets/e1.jpg")
						]
					},
					{
						titel: "二，诉前财产保全：诉前财产保全阶段调解处置，更保证回款率",
						content: "诉前保全指在起诉立案之前保全财产。保全可在诉前、立案后、申请执行后提起申请。可保全还款人银行账户、房产、汽车、股权等财产类别，包括支付宝或微信账户、理财产品、公积金等。并将设定“E法通”联合地方多家法院资源，基于智能法律科技软件进行批量入案、案件管理，智能分案，案卷批量一键生成，回款数据线上监控等，高效实现诉前财保全流程管理。",
						imgs: [
							require("@/assets/e2.png"),
							require("@/assets/e3.png")
						]
					},
					{
						titel: "三，民事诉讼：通过立案处置，加大回款率",
						content: "“E法通”打通多地方司法处置快立渠道，通过资产解决运营团队线上法院进行立案、审结、执行，推进法院办案效率，提升回款率。并将设定“E法通”法律科技软件未来可实现电子存证批量管理、全国各地律师团队接单立案；案卷批量一键生成，电子快签，案件阶段与回款数据线上统计监控，立案管理等线上接单辅助线下智能化立案诉讼等多元化处置形式，利用科技软件服务加大回款率。",
						imgs: [
							require("@/assets/e4.jpeg")
						]
					},
					{
						titel: "四，仲裁/执行：缩短裁决周期，确保回款",
						content: "“E法通”联合多地仲裁机构与执行资源，依托平台技术将类型案件的标准化处理，极大简化仲裁流程，缩短裁决周期，快速拿到有效裁决书。线上裁决，电子送达，线下送执行，确保回款率。",
						imgs: [
							
							require("@/assets/e5.png"),
							require("@/assets/e6.png")
						]
					},
					
				]
			};
		},
		created() {
			var modelId = 6;
			var banners = [];
			var article = [];
			var that = this;
			getHome({
				modelId
			}).then((res) => {
				if (res.code == 200 && res.data.length > 0) {

					res.data.forEach((item) => {
						if (item.titleType == 0) { //文章
							var bn = {};
							bn.url = item.fileList[0].filePath;
							banners.push(bn)
						}
						if (item.titleType == 1) { //轮播图
							article.push(item)
						}
					})
					console.log(article)
					that.article = article;
					that.banners = banners;
				}
			})
		},
		mounted() {
			window.addEventListener("scroll", this.handleScroll); // 在挂载后监听滚动事件
			this.divs = [ // 定义一个数组，存储每个div的引用和对应的数据
				{
					ref: this.$refs.text1,
					show: "show1",
					threshold: 0
				}
			]
		},
		beforeDestroy() {
			window.removeEventListener("scroll", this.handleScroll); // 在销毁前移除滚动事件
		},
		components: {
			tabBar,
			swiper,
			fixedBottomRight
		},
		methods: {
			swiperleft() {},
			swiperight() {},
			clickbj1() {
				window.location.href = "https://www.yindeng.com.cn/Home/fggf/cn/qgx/20211101/1242473.shtml"
			},
			handleScroll() { // 定义一个方法，用于判断元素是否进入可视区域
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop; // 获取滚动距离
				let elements = document.querySelectorAll('.dt');
				elements.forEach(div => { // 遍历数组中的每个对象
					let offsetTop = div.offsetTop; // 获取元素距离顶部的位置
					let threshold = 0; // 获取元素对应的阈值
					if (scrollTop + window.innerHeight > offsetTop + threshold) { // 判断元素是否进入可视区域
						if (div.classList.contains('animation') == false) { //不存在动画类，则添加
							div.classList.add('animation')
						}
					}
				})
			},
			blackDivClick(e) {
				let btn2 = e.currentTarget.previousElementSibling;
				btn2.classList.add("active"); // 给按钮元素添加一个active类名
			},
			shadeClick(e) {
				let btn = e.currentTarget;
				btn.classList.remove("active"); // 给按钮元素添加一个active类名
			},
			arrowClick(url) {
				this.$router.push({
					name: url
				})
			}
		}
	};
</script>

<style lang="scss" scoped>
	@keyframes moveUp {
		from {
			transform: translateY(100%);
			opacity: 0;
		}

		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	.frame {
		position: absolute;
		width: 100%;
		background-color: rgb(224, 224, 224);
		touch-action: pan-y !important;
	}

	.container-box {
		display: flex;
		flex-direction: column;


		.imgStyle {
			height: 100%;
			width: 100%;
		}

		.header {
			z-index: 999;
			top: 0;
			position: fixed;
			background-color: #fff;
			-webkit-transform: translateZ(0);
			opacity: 0.85;

			.headerFrame {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: 7.5vh;
				width: 100vw;
			}

			.headerChild {
				height: 59%;
				width: 100vw;
			}


		}

		.content {
			display: flex;
			flex-direction: column;
			margin-top: 7.5vh;
			width: 100vw;

			// 山哩商城
			.shoppingMall {
				display: flex;
				flex-direction: column;
				padding-left: 20px;
				padding-right: 20px;

				.title {
					text-align: center;
					border-bottom: rgb(0, 56, 121) 1px solid;
					color: rgb(0, 56, 121);
					font-size: 25px;
					font-weight: 600;
				}

				.textContent {
					padding-top: 20px;
					text-align: justify;
				}

				.textBottom {
					padding-top: 20px;
					padding-bottom: 20px;
					font-weight: 600;
				}

				.childTiltle {
					font-weight: 700;
				}

				.childContent {
					text-align: justify;
					padding-top: 10px;
				}
				.childImg {
					margin-top: 10px;
					border-radius: 5px;
					overflow: hidden;
					img {
						margin-top: 5px;
					}
				}
				.shoppingMallBg {
					height: 26vh;

				}

				.diagram {
					top: -5rem;
					position: relative;
					width: 80%;
				}

				.shoppingMallContent {
					margin-top: 0.2rem;
					display: flex;
					flex-direction: column;
					align-items: center;
					background-color: #840000;
					color: #fff;

					.contentChild {
						top: 0rem;
						position: relative;
						height: 50%;
						display: flex;
						flex-direction: column;
						align-items: center;

						.contentFontFrame {
							font-weight: bold;
							padding: 0.5rem;
							border-bottom: solid 2px;
							font-size: 1.2rem;
						}

						.contentFontFrame1 {
							padding-top: 1rem;
							font-size: 0.9rem;
						}

						.contentFontFrame2 {
							font-size: 0.9rem;
						}

						.contentCode {
							margin: 1rem;
							width: 100%;
						}
					}
				}
			}

			// 服务店
			.serverFrame {
				/* margin-top: 1rem; */
				display: flex;
				flex-direction: column;
				align-items: center;
				width: 100%;
				background-color: #840000;
				/* height: 45vh; */

				.serverFrameFont {
					margin: 0.5rem 2rem;
					height: 30%;
					display: flex;
					flex-direction: column;
					align-items: center;
					color: #fff;

					.serverFrameTitle {
						padding: 0.5rem;
						font-weight: bold;
						font-size: 1.2rem;
						border-bottom: solid 2px #fff;
					}

					.serverFrameContent {
						padding-top: 0.5rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						font-size: 0.5rem;
					}
				}

				.serverFrameImg {
					margin-bottom: 1rem;
					height: 70%;
					width: 100%;
				}
			}

			// 农场
			.farmFrame {
				margin-top: 1rem;
				height: 60vh;
				display: flex;
				flex-direction: column;

				.farmFrameChild {
					height: 40%;
					width: 100%;
				}

				.farmFrameChild1 {
					margin-top: 2%;
					height: 58%;
					width: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;

					.farmFrameChildImg {
						display: flex;
						justify-content: space-between;
						height: 50%;
						width: 96%;
						position: relative;
						top: 1rem;

						.farmFrameChildImg1 {
							height: 100%;
							width: 48%;
						}
					}

					.farmFrameChildContent {
						padding-top: 1rem;
						display: flex;
						flex-direction: column;
						align-items: center;
						height: 50%;
						width: 100%;
						background-color: #840000;
						color: #fff;

						.farmChildFrame {
							width: 94%;
						}

						.farmChildFont {
							width: 35%;
							padding: 0.5rem;
							font-weight: bold;
							font-size: 1.2rem;
							border-bottom: solid 2px #fff;
						}

						.farmChildFont1 {
							margin-top: 1rem;
							font-size: 0.5rem;
						}
					}
				}
			}

			// 商学院
			.business {
				margin-top: 1rem;
				display: flex;
				flex-direction: column;
				height: 40vh;

				.businessHeader {
					padding: 1rem;
					height: 15%;
					background-color: #840000;
				}

				.businessMiddle {
					display: flex;
					justify-content: center;
					height: 40%;

					.businessMiddleImg {
						top: -1rem;
						position: relative;
						height: 20vh;
						width: 60%;
					}
				}

				.businessFooter {
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					align-items: center;
					height: 45%;
					width: 100%;
					background-color: #840000;

					.businessFooterChild {
						margin-bottom: 3%;
						height: 80%;
						width: 80%;
						color: #fff;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;

						.businessFooterFont {
							padding: 0.5rem;
							border-bottom: solid 2px;
							font-size: 1.2rem;
							font-weight: bold;
						}

						.businessFooterFont1 {
							margin-top: 0.5rem;
							display: flex;
							flex-direction: column;
							align-items: center;
							font-size: 0.5rem;
						}
					}
				}
			}
		}
	}

	.tabBarFontFrame {
		pointer-events: none;
		color: #fff;
		height: 5vh;
		width: 100%;
		position: absolute;
		top: 17.5vh;
		z-index: 3;
		display: flex;
		align-items: center;
		flex-direction: column;
		animation: moveUp 3s 1;

		.tabBarFont {
			letter-spacing: 2px;
			font-weight: bold;
			font-size: 1.3rem;
		}

		.tabBarFont1 {
			margin-top: 2%;
			font-size: 1rem;
			letter-spacing: 2px;
		}
	}

	.animation {
		animation: moveUp 3s 1;
	}

	.black-div {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.85);
		/* 设置背景色为半透明的黑色 */
		color: white;
		font-size: 24px;
		text-align: center;
		line-height: 100%;
		display: none;
	}

	.container {
		display: flex;
		/* 设置容器为flex布局 */
		justify-content: center;
		/* 设置水平居中 */
		align-items: center;
		/* 设置垂直居中 */
		padding-top: 15px;
	}

	.circle-div {
		width: 42px;
		/* 设置圆形DIV的宽度 */
		height: 42px;
		/* 设置圆形DIV的高度 */
		border-radius: 50%;
		/* 设置圆形DIV的边框半径为50% */
		background-color: white;
		/* 设置圆形DIV的背景色为绿色 */
		position: relative;
		/* 设置圆形DIV的定位为相对定位 */
	}

	.arrow-img {
		/* 设置图片的样式 */
		width: 54px;
		/* 设置图片的宽度 */
		height: 54px;
		/* 设置图片的高度 */
		position: absolute;
		/* 设置图片的定位为绝对定位 */
		top: 50%;
		/* 设置图片的上偏移为50% */
		left: 50%;
		/* 设置图片的左偏移为50% */
		transform: translate(-50%, -50%);
		/* 使用transform属性调整图片的位置，使其居中 */
	}

	.active {
		display: block;
	}

	.mg {
		margin-top: 30px;
	}

	.shade {
		position: absolute;
		top: 30%;
		width: 100%;
		text-align: center;

		.shade-title {
			font-size: 13px;
			padding-left: 20%;
			padding-right: 20%;
		}

		.shade-line {
			height: 1px;
			width: 62px;
			background: #015198 none repeat scroll 0 0;
			margin: 12px auto 6px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/iphone/generalLaw.vue